// WARNING: DO NOT EDIT. This file is Auto-Generated by AWS Mobile Hub. It will be overwritten.

// Copyright 2017-2018 Amazon.com, Inc. or its affiliates (Amazon). All Rights Reserved.
// Code generated by AWS Mobile Hub. Amazon gives unlimited permission to
// copy, distribute and modify it.

// AWS Mobile Hub Project Constants
const awsmobile = {
    'aws_app_analytics': 'enable',
    'aws_cognito_identity_pool_id': 'us-east-1:da2c2fd5-14d1-4a9f-a234-3f638b66c3b6',
    'aws_cognito_region': 'us-east-1',
    'aws_mobile_analytics_app_id': 'f9041cd5496249cabc723a30ccbc2665',
    'aws_mobile_analytics_app_region': 'us-east-1',
    'aws_project_id': '65d6a61e-f749-437a-b7e0-773d1bb2da6b',
    'aws_project_name': 'analytics-prod',
    'aws_project_region': 'us-east-1',
    'aws_resource_name_prefix': 'analyticsprod-mobilehub-1793669640',
    'aws_sign_in_enabled': 'enable',
    'aws_user_files': 'enable',
    'aws_user_files_s3_bucket': 'analyticsprod-userfiles-mobilehub-1793669640',
    'aws_user_files_s3_bucket_region': 'us-east-1',
    'aws_user_pools': 'enable',
    'aws_user_pools_id': 'us-east-1_udTqeUVQe',
    'aws_user_pools_mfa_type': 'OFF',
    'aws_user_pools_web_client_id': '2leehjius9aotnk99palutb54p',
    "aws_appsync_graphqlEndpoint": "https://bfqx5eqsffaizm4hqikvwfz4uu.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-xrj6tdapmbbbtidgdiog5n3pcy"
}

export default awsmobile;
